import { BaseApi, ListResponse, PaginatedResponse } from '@bv/api';

class PlaceholdersApi extends BaseApi {
  constructor() {
    super('conversations/messages/placeholders');
  }

  public async create(data: {
    search?: string;
    contactId?: string;
  }): Promise<PaginatedResponse<string> | ListResponse<string>> {
    return this.request({
      method: 'post',
      data,
    }) as Promise<PaginatedResponse<string> | ListResponse<string>>;
  }
}

export default new PlaceholdersApi();
